import LocationBadge from './LocationBadge';

export default LocationBadge;
